import { createReducer, on } from '@ngrx/store';
import * as DocumentsActions from './documents.actions';
import { initialDocumentsState } from './documents.state';

export const documentsReducer = createReducer(
  initialDocumentsState,

  on(DocumentsActions.loadDocuments, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.loadDocumentsSuccess, (state, { documents, pagination }) => ({
    ...state,
    documents,
    pagination,
    loading: false,
    error: null,
  })),

  on(DocumentsActions.loadDocumentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentsActions.createDocument, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.createDocumentSuccess, (state, { document }) => ({
    ...state,
    documents: [ ...state.documents, document ],
    loading: false,
    error: null,
  })),

  on(DocumentsActions.createDocumentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentsActions.updateDocument, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.updateDocumentSuccess, (state, { document }) => ({
    ...state,
    documents: state.documents.map(item => item.id === document.id ? document : item),
    loading: false,
    error: null,
  })),

  on(DocumentsActions.updateDocumentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentsActions.deleteDocument, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.deleteDocumentSuccess, (state, { id }) => ({
    ...state,
    documents: state.documents.filter(document => document.id !== id),
    loading: false,
    error: null,
  })),

  on(DocumentsActions.deleteDocumentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentsActions.uploadDocumentFile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.uploadDocumentFileSuccess, (state, { document }) => ({
    ...state,
    documents: state.documents.map(item => item.id === document.id ? document : item),
    loading: false,
    error: null,
  })),

  on(DocumentsActions.uploadDocumentFileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(DocumentsActions.deleteDocumentFile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DocumentsActions.deleteDocumentFileSuccess, (state, { document }) => ({
    ...state,
    documents: state.documents.map(item => item.id === document.id ? document : item),
    loading: false,
    error: null,
  })),

  on(DocumentsActions.deleteDocumentFileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
